import React from "react";

type Action =
  | { type: "updateCartIcon"; quantity: number }
  | { type: "scrollToBlog"; scrollToBlog: boolean };

type Dispatch = (action: Action) => void;
interface State {
  quantity: number;
  scrollToBlog: boolean;
}
type GlobalProviderProps = { children: React.ReactNode };

const GlobalStateContext = React.createContext<State | undefined>(undefined);
const GlobalDispatchContext = React.createContext<Dispatch | undefined>(
  undefined
);

function globalReducer(state: State, action: Action) {
  switch (action.type) {
    case "updateCartIcon": {
      return { ...state, quantity: action.quantity };
    }
    case "scrollToBlog": {
      return { ...state, scrollToBlog: action.scrollToBlog };
    }
    default: {
      throw new Error(`Unhandled action type`);
    }
  }
}
function GlobalProvider({ children }: GlobalProviderProps): JSX.Element {
  const [state, dispatch] = React.useReducer(globalReducer, {
    quantity: 0,
    scrollToBlog: false,
  });
  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
}
function useGlobalState(): State {
  const context = React.useContext(GlobalStateContext);

  return context;
}
function useGlobalDispatch(): Dispatch {
  const context = React.useContext(GlobalDispatchContext);

  return context;
}
export { GlobalProvider, useGlobalState, useGlobalDispatch };
